import React, { Fragment, useContext } from "react";
import axios from "axios";

import Icon from "../Icon";

import { EligibilityContext } from "../../contexts/EligibilityContext";

const apiUrl = "/wp-json/salesforce/v1/funds";

const SearchResult = (props) => {
  const context = useContext(EligibilityContext);

  const handleSelect = async (event) => {
    event.preventDefault();
    props.setError(""); // clear validation messages defined in Search

    context.actions.setDiseaseFund({
      salesforceId: props.result.Id,
      fundId: props.result.Fund_ID,
      groupId: props.result.Fund_ID,
      name: props.result.Name,
      fundStatus: props.result.Fund_Status.toLowerCase(),
    });

    await axios
      .get(`${apiUrl}/${props.result.Fund_ID}?medications=true&criteria=true`)
      .then((response) => {
        context.actions.setDiseaseFund({
          salesforceId: props.result.Id,
          fundId: props.result.Fund_ID,
          type: props.result.Type,
          groupId: props.result.Fund_ID,
          name: props.result.Name,
          fundStatus: props.result.Fund_Status.toLowerCase(),
          permalink: props.result.permalink,
          insuranceTypes:
            response.data.funds[0].Public_Allowed_Insurance_Types.split(";"),
          medications: response.data.funds[0].medications,
          eligibilityCriteria: response.data.funds[0].eligibilityCriteria,
        });
      })
      .catch((error) => {
        props.setQuery("");
        context.actions.renderError();
      });
  };

  return (
    <Fragment>
      {props.result && (
        <li className="QuickSearch-results-item f-scale-body">
          <button
            type="button"
            className="QuickSearch-results-link btn-reset"
            onClick={(event) => handleSelect(event)}
          >
            <span>{props.result.Name}</span>
            <span>
              <Icon
                name="upLeftArrow"
                width="9"
                height="8"
                className="QuickSearch-results-icon"
              />
            </span>
          </button>
        </li>
      )}
    </Fragment>
  );
};

export default SearchResult;
